import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Explore from "@/pages/Explore";
import TruckProfile from "@/pages/TruckProfile";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Corporate from "@/pages/Corporate";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import OwnerDashboard from "@/pages/OwnerDashboard";
import OrganizerDashboard from "@/pages/OrganizerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Founding from "@/pages/Founding";
import Claim from "@/pages/Claim";
import Concierge from "@/pages/Concierge";

const Shell = ({ children, hideFooter }) => (
  <>
    <Navbar />
    {children}
    {!hideFooter && <Footer />}
  </>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Shell><Landing /></Shell>} />
            <Route path="/founding" element={<Shell><Founding /></Shell>} />
            <Route path="/claim" element={<Shell><Claim /></Shell>} />
            <Route path="/explore" element={<Shell hideFooter><Explore /></Shell>} />
            <Route path="/truck/:id" element={<Shell><TruckProfile /></Shell>} />
            <Route path="/events" element={<Shell><Events /></Shell>} />
            <Route path="/events/:id" element={<Shell><EventDetail /></Shell>} />
            <Route path="/corporate" element={<Shell><Corporate /></Shell>} />
            <Route path="/concierge" element={<Shell><Concierge /></Shell>} />
            <Route path="/pricing" element={<Shell><Pricing /></Shell>} />
            <Route path="/login" element={<Shell><Login /></Shell>} />
            <Route path="/register" element={<Shell><Register /></Shell>} />
            <Route path="/payment/success" element={<Shell><PaymentSuccess /></Shell>} />
            <Route path="/dashboard/owner" element={<ProtectedRoute roles={["owner"]}><Shell><OwnerDashboard /></Shell></ProtectedRoute>} />
            <Route path="/dashboard/organizer" element={<ProtectedRoute roles={["organizer", "admin"]}><Shell><OrganizerDashboard /></Shell></ProtectedRoute>} />
            <Route path="/dashboard/admin" element={<ProtectedRoute roles={["admin"]}><Shell><AdminDashboard /></Shell></ProtectedRoute>} />
          </Routes>
          <Toaster position="bottom-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
